// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type ProspectEmployeeCensus } from '../prospects/types'

export function useCreateCensus ({ prospectId }: { prospectId: string }) {
  return useMutation<ProspectEmployeeCensus, GrapeAPIErrorType, FormData>({
    mutationFn: async (formData: FormData) => {
      const request = new FetchRequest(
        'post',
        `/api/web/quoting/prospects/${prospectId}/census`,
        {
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
